import * as React from 'react';
import { RouteComponentProps, withRouter, Link } from 'react-router-dom';
import { Redirect } from 'react-router';
import axios from '../../helpers/axios';
import { Grid, Card, CardContent, CardActions, CardHeader, IconButton, Button, Menu, MenuItem, Modal, Box, Divider, FormControl, Select, InputLabel, TextField, Typography } from '@mui/material';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { withTranslation, WithTranslation } from 'react-i18next';
import OperationsHeader from './OperationsHeader';
import { DataGrid, GridRowParams, GridActionsCellItem, GridCellParams, GridToolbarContainer, GridToolbarExport } from '@mui/x-data-grid';
import { EditOutlined, Add, Security as SecurityIcon, FileCopy as FileCopyIcon, MoreHorizOutlined, CloseOutlined } from '@mui/icons-material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';

const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '65%',
    p: 4,
};

function CustomToolbar() {
    return (
        <GridToolbarContainer className='exportButton'>
            <GridToolbarExport variant='contained' csvOptions={{ fileName: 'Outgoing-waste' }} />
        </GridToolbarContainer>
    );
}

export interface IProps {
    user: {
        id: number;
        name: string;
        email: string;
        role: string;
        is_active: boolean;
    };
}

export interface IState {
    sorting_agents: any[];
    material_types: any;
    types: any[];
    routes: any[];
    pageSize: number;
    anchorEl: any;
    showAddWaste: boolean;
    /**Add waste by Vehicle Form Data */
    agent_id?: any;
    route_id?: any;
    unit?: string;
    date?: string | null;
    vehicle_id?: any;
    vehicle_capacity?: any;
    price_per_unit?: number;
    total_price?: number;
    recyclables_percentage?: number;
    recyclables_kg?: number;
    organics_percentage?: number;
    organics_kg?: number;
    residual_percentage?: number;
    residual_kg?: number;
    material?: any;
    material_type?: any;
    waste_quantity?: number;
    filter: any;
    community_type: any;
    /**Add waste by Vehicle Form Data */
}

class Distribution extends React.Component<RouteComponentProps & IProps & WithTranslation, IState> {
    constructor(props: RouteComponentProps & IProps & WithTranslation) {
        super(props);
        this.state = {
            sorting_agents: [],
            material_types: [],
            types: [],
            routes: [],
            pageSize: 5,
            anchorEl: null,
            showAddWaste: false,
            date: null,
            waste_quantity: 0,
            filter: '',
            community_type: '',
        }
    }
    public componentDidMount(): void {
        // axios.get(`routes`).then(response => {
        //     this.setState({ routes: response.data.data })
        // });
        this.setState({
            sorting_agents: [
                {
                    "id": "6953",
                    "agent_name": "PT. PRATAMA INTERDANA FINANCE",
                    "mobile": "8199934561",
                    "email": "pratama@gmail.com",
                    "type": "Payment collection agent",
                    "outstanding_balance": 0,
                    "status": "Active"
                },
                {
                    "priority": "2",
                    "id": "7092",
                    "agent_name": "KULO SUPRATMAN",
                    "mobile": "8199934562",
                    "email": "kulo@gmail.com",
                    "type": "Payment collection agent",
                    "outstanding_balance": 350000,
                    "status": "Active"
                },
                {
                    "priority": "3",
                    "id": "7093",
                    "agent_name": "KT WIBAYA YUANA",
                    "mobile": "8199934563",
                    "email": "wibaya@gmail.com",
                    "type": "Payment collection agent",
                    "outstanding_balance": 0,
                    "status": "Inactive"
                },
                {
                    "priority": "4",
                    "id": "7094",
                    "agent_name": "BU SUBAWA / FOTOCOPY",
                    "mobile": "8199934564",
                    "email": "subawa@gmail.com",
                    "type": "Waste and Administration",
                    "outstanding_balance": 0,
                    "status": "Active"
                },
                {
                    "priority": "5",
                    "id": "7095",
                    "agent_name": "NI LUH PUSPAWATI",
                    "mobile": "8199934565",
                    "email": "puspawati@gmail.com",
                    "type": "Waste and Administration",
                    "outstanding_balance": 0,
                    "status": "Active"
                },
                {
                    "priority": "6",
                    "id": "7096",
                    "agent_name": "PAK MUDIASIH / KANTOR",
                    "mobile": "8199934566",
                    "email": "mudiasih@gmail.com",
                    "type": "Waste and Administration",
                    "outstanding_balance": 0,
                    "status": "Active"
                },
                {
                    "priority": "7",
                    "id": "7097",
                    "agent_name": "TOKO CAT CITRA WARNA",
                    "mobile": "8199934567",
                    "email": "warna@gmail.com",
                    "type": "Waste and Administration",
                    "outstanding_balance": 0,
                    "status": "Active"
                }
            ],
            material_types: {
                Plastik: [
                    {
                        "id": 1,
                        "name": "PET kotor",
                        "hierarchy_id": 1,
                        "material": "Plastik",
                        "created_at": "2021-03-18 15:15:05",
                        "updated_at": "2021-03-18 15:15:05"
                    },
                    {
                        "id": 2,
                        "name": "PET berwarna bersih",
                        "hierarchy_id": 1,
                        "material": "Plastik",
                        "created_at": "2021-03-18 15:15:05",
                        "updated_at": "2021-03-18 15:15:05"
                    },
                    {
                        "id": 3,
                        "name": "PET biru muda bersih",
                        "hierarchy_id": 1,
                        "material": "Plastik",
                        "created_at": "2021-03-18 15:15:05",
                        "updated_at": "2021-03-18 15:15:05"
                    },
                    {
                        "id": 4,
                        "name": "PET bening bersih",
                        "hierarchy_id": 1,
                        "material": "Plastik",
                        "created_at": "2021-03-18 15:15:05",
                        "updated_at": "2021-03-18 15:15:05"
                    },
                    {
                        "id": 5,
                        "name": "Gelas\/sok dengan label belum dilepas atau kotor (PP)",
                        "hierarchy_id": 1,
                        "material": "Plastik",
                        "created_at": "2021-03-18 15:15:05",
                        "updated_at": "2021-03-18 15:15:05"
                    },
                    {
                        "id": 6,
                        "name": "Gelas\/sok dengan label sudah dilepas atau bersih (PP)",
                        "hierarchy_id": 1,
                        "material": "Plastik",
                        "created_at": "2021-03-18 15:15:05",
                        "updated_at": "2021-03-18 15:15:05"
                    },
                    {
                        "id": 7,
                        "name": "Ale-ale, teh gelas, gelas plastik dengan sablonan (PP)",
                        "hierarchy_id": 1,
                        "material": "Plastik",
                        "created_at": "2021-03-18 15:15:05",
                        "updated_at": "2021-03-18 15:15:05"
                    },
                    {
                        "id": 8,
                        "name": "Jerigen oli, putihan (HDPE - termasuk botol shampoo, cairan pembersih, dll)",
                        "hierarchy_id": 1,
                        "material": "Plastik",
                        "created_at": "2021-03-18 15:15:05",
                        "updated_at": "2021-03-18 15:15:05"
                    },
                    {
                        "id": 9,
                        "name": "Jerigen putih (per buah) (HDPE)",
                        "hierarchy_id": 1,
                        "material": "Plastik",
                        "created_at": "2021-03-18 15:15:06",
                        "updated_at": "2021-03-18 15:15:06"
                    },
                    {
                        "id": 10,
                        "name": "Plastik keras, pralon, yakult",
                        "hierarchy_id": 1,
                        "material": "Plastik",
                        "created_at": "2021-03-18 15:15:06",
                        "updated_at": "2021-03-18 15:15:06"
                    },
                    {
                        "id": 11,
                        "name": "Emberan (HDPE)",
                        "hierarchy_id": 1,
                        "material": "Plastik",
                        "created_at": "2021-03-18 15:15:06",
                        "updated_at": "2021-03-18 15:15:06"
                    },
                    {
                        "id": 12,
                        "name": "PE, plastik atau kresek bening",
                        "hierarchy_id": 1,
                        "material": "Plastik",
                        "created_at": "2021-03-18 15:15:06",
                        "updated_at": "2021-03-18 15:15:06"
                    },
                    {
                        "id": 13,
                        "name": "PE, plastik atau kresek semua warna",
                        "hierarchy_id": 1,
                        "material": "Plastik",
                        "created_at": "2021-03-18 15:15:06",
                        "updated_at": "2021-03-18 15:15:06"
                    },
                    {
                        "id": 14,
                        "name": "Tutup PE (dari botol PET, galon, dll)",
                        "hierarchy_id": 1,
                        "material": "Plastik",
                        "created_at": "2021-03-18 15:15:06",
                        "updated_at": "2021-03-18 15:15:06"
                    },
                    {
                        "id": 15,
                        "name": "Plastik hitam besar (LDPE)",
                        "hierarchy_id": 1,
                        "material": "Plastik",
                        "created_at": "2021-03-18 15:15:06",
                        "updated_at": "2021-03-18 15:15:06"
                    },
                    {
                        "id": 16,
                        "name": "Karung kecil",
                        "hierarchy_id": 1,
                        "material": "Plastik",
                        "created_at": "2021-03-18 15:15:06",
                        "updated_at": "2021-03-18 15:15:06"
                    },
                    {
                        "id": 17,
                        "name": "Karung sedang",
                        "hierarchy_id": 1,
                        "material": "Plastik",
                        "created_at": "2021-03-18 15:15:06",
                        "updated_at": "2021-03-18 15:15:06"
                    },
                    {
                        "id": 18,
                        "name": "Karung besar",
                        "hierarchy_id": 1,
                        "material": "Plastik",
                        "created_at": "2021-03-18 15:15:06",
                        "updated_at": "2021-03-18 15:15:06"
                    },
                    {
                        "id": 19,
                        "name": "Karung sobek",
                        "hierarchy_id": 1,
                        "material": "Plastik",
                        "created_at": "2021-03-18 15:15:06",
                        "updated_at": "2021-03-18 15:15:06"
                    }
                ],
                Kertas: [
                    {
                        "id": 20,
                        "name": "Kardus",
                        "hierarchy_id": 1,
                        "material": "Kertas",
                        "created_at": "2021-03-18 15:21:48",
                        "updated_at": "2021-03-18 15:21:48"
                    },
                    {
                        "id": 21,
                        "name": "HVS\/Kertas putih",
                        "hierarchy_id": 1,
                        "material": "Kertas",
                        "created_at": "2021-03-18 15:21:48",
                        "updated_at": "2021-03-18 15:21:48"
                    },
                    {
                        "id": 22,
                        "name": "Majalah",
                        "hierarchy_id": 1,
                        "material": "Kertas",
                        "created_at": "2021-03-18 15:21:48",
                        "updated_at": "2021-03-18 15:21:48"
                    },
                    {
                        "id": 23,
                        "name": "Arsip\/buram",
                        "hierarchy_id": 1,
                        "material": "Kertas",
                        "created_at": "2021-03-18 15:21:48",
                        "updated_at": "2021-03-18 15:21:48"
                    },
                    {
                        "id": 24,
                        "name": "Koran",
                        "hierarchy_id": 1,
                        "material": "Kertas",
                        "created_at": "2021-03-18 15:21:48",
                        "updated_at": "2021-03-18 15:21:48"
                    },
                    {
                        "id": 25,
                        "name": "Duplex",
                        "hierarchy_id": 1,
                        "material": "Kertas",
                        "created_at": "2021-03-18 15:21:48",
                        "updated_at": "2021-03-18 15:21:48"
                    },
                    {
                        "id": 26,
                        "name": "Kemasan minuman karton \/ UBC (Used beverage carton)",
                        "hierarchy_id": 1,
                        "material": "Kertas",
                        "created_at": "2021-03-18 15:21:48",
                        "updated_at": "2021-03-18 15:21:48"
                    },
                    {
                        "id": 27,
                        "name": "Buku pelajaran kertas putih",
                        "hierarchy_id": 1,
                        "material": "Kertas",
                        "created_at": "2021-03-18 15:21:48",
                        "updated_at": "2021-03-18 15:21:48"
                    },
                    {
                        "id": 28,
                        "name": "Buku pelajaran kertas buram",
                        "hierarchy_id": 1,
                        "material": "Kertas",
                        "created_at": "2021-03-18 15:21:48",
                        "updated_at": "2021-03-18 15:21:48"
                    }
                ],
                "Logam": [
                    {
                        "id": 29,
                        "name": "Aluminium Tebal",
                        "hierarchy_id": 1,
                        "material": "Logam",
                        "created_at": "2021-03-18 15:25:44",
                        "updated_at": "2021-03-18 15:25:44"
                    },
                    {
                        "id": 30,
                        "name": "Aluminium tipis",
                        "hierarchy_id": 1,
                        "material": "Logam",
                        "created_at": "2021-03-18 15:25:44",
                        "updated_at": "2021-03-18 15:25:44"
                    },
                    {
                        "id": 31,
                        "name": "Omplongan (tin)",
                        "hierarchy_id": 1,
                        "material": "Logam",
                        "created_at": "2021-03-18 15:25:44",
                        "updated_at": "2021-03-18 15:25:44"
                    },
                    {
                        "id": 32,
                        "name": "Besi tebal",
                        "hierarchy_id": 1,
                        "material": "Logam",
                        "created_at": "2021-03-18 15:25:44",
                        "updated_at": "2021-03-18 15:25:44"
                    },
                    {
                        "id": 33,
                        "name": "Besi tipis",
                        "hierarchy_id": 1,
                        "material": "Logam",
                        "created_at": "2021-03-18 15:25:44",
                        "updated_at": "2021-03-18 15:25:44"
                    },
                    {
                        "id": 34,
                        "name": "Seng",
                        "hierarchy_id": 1,
                        "material": "Logam",
                        "created_at": "2021-03-18 15:25:44",
                        "updated_at": "2021-03-18 15:25:44"
                    },
                    {
                        "id": 35,
                        "name": "Omplong (kaleng susu, kaleng biskuit, dll) (tin)",
                        "hierarchy_id": 1,
                        "material": "Logam",
                        "created_at": "2021-03-18 15:25:44",
                        "updated_at": "2021-03-18 15:25:44"
                    },
                    {
                        "id": 36,
                        "name": "Paku",
                        "hierarchy_id": 1,
                        "material": "Logam",
                        "created_at": "2021-03-18 15:25:44",
                        "updated_at": "2021-03-18 15:25:44"
                    },
                    {
                        "id": 37,
                        "name": "Omplong sterno (tin)",
                        "hierarchy_id": 1,
                        "material": "Logam",
                        "created_at": "2021-03-18 15:25:44",
                        "updated_at": "2021-03-18 15:25:44"
                    }
                ],
                Kaca: [
                    {
                        "id": 38,
                        "name": "Bir bintang besar (per botol)",
                        "hierarchy_id": 1,
                        "material": "Kaca",
                        "created_at": "2021-03-18 15:30:31",
                        "updated_at": "2021-03-18 15:30:31"
                    },
                    {
                        "id": 39,
                        "name": "Bir bintang kecil (per botol)",
                        "hierarchy_id": 1,
                        "material": "Kaca",
                        "created_at": "2021-03-18 15:30:31",
                        "updated_at": "2021-03-18 15:30:31"
                    },
                    {
                        "id": 40,
                        "name": "Botol bening (per botol)",
                        "hierarchy_id": 1,
                        "material": "Kaca",
                        "created_at": "2021-03-18 15:30:31",
                        "updated_at": "2021-03-18 15:30:31"
                    },
                    {
                        "id": 41,
                        "name": "Botol warna (per botol)",
                        "hierarchy_id": 1,
                        "material": "Kaca",
                        "created_at": "2021-03-18 15:30:31",
                        "updated_at": "2021-03-18 15:30:31"
                    },
                    {
                        "id": 42,
                        "name": "Botol kecap (per botol)",
                        "hierarchy_id": 1,
                        "material": "Kaca",
                        "created_at": "2021-03-18 15:30:31",
                        "updated_at": "2021-03-18 15:30:31"
                    },
                    {
                        "id": 43,
                        "name": "Botol sosro, coca cola, sprite kecil (per botol)",
                        "hierarchy_id": 1,
                        "material": "Kaca",
                        "created_at": "2021-03-18 15:30:31",
                        "updated_at": "2021-03-18 15:30:31"
                    },
                    {
                        "id": 44,
                        "name": "Botol orson (per botol)",
                        "hierarchy_id": 1,
                        "material": "Kaca",
                        "created_at": "2021-03-18 15:30:31",
                        "updated_at": "2021-03-18 15:30:31"
                    },
                    {
                        "id": 45,
                        "name": "UC 1000 (per botol)",
                        "hierarchy_id": 1,
                        "material": "Kaca",
                        "created_at": "2021-03-18 15:30:31",
                        "updated_at": "2021-03-18 15:30:31"
                    }
                ],
                Lainnya: [
                    {
                        "id": 46,
                        "name": "Sachet seperti rinso, molto, sunlight, kopi, snack, dll (plastik fleksibel \/ multilayer)",
                        "hierarchy_id": 1,
                        "material": "Lainnya",
                        "created_at": "2021-03-18 15:35:27",
                        "updated_at": "2021-03-18 15:35:27"
                    },
                    {
                        "id": 47,
                        "name": "Tekstil \/ kain \/ pakaian",
                        "hierarchy_id": 1,
                        "material": "Lainnya",
                        "created_at": "2021-03-18 15:35:27",
                        "updated_at": "2021-03-18 15:35:27"
                    },
                    {
                        "id": 48,
                        "name": "Styrofoam (PS)",
                        "hierarchy_id": 1,
                        "material": "Lainnya",
                        "created_at": "2021-03-18 15:35:27",
                        "updated_at": "2021-03-18 15:35:27"
                    },
                    {
                        "id": 49,
                        "name": "Rongsokan",
                        "hierarchy_id": 1,
                        "material": "Lainnya",
                        "created_at": "2021-03-18 15:35:28",
                        "updated_at": "2021-03-18 15:35:28"
                    },
                    {
                        "id": 50,
                        "name": "Mizone",
                        "hierarchy_id": 1,
                        "material": "Lainnya",
                        "created_at": "2021-03-18 15:35:28",
                        "updated_at": "2021-03-18 15:35:28"
                    },
                    {
                        "id": 51,
                        "name": "...",
                        "hierarchy_id": 1,
                        "material": "Lainnya",
                        "created_at": "2021-03-18 15:35:28",
                        "updated_at": "2021-03-18 15:35:28"
                    },
                    {
                        "id": 52,
                        "name": "ACCU",
                        "hierarchy_id": 1,
                        "material": "Lainnya",
                        "created_at": "2021-03-18 15:35:28",
                        "updated_at": "2021-03-18 15:35:28"
                    },
                    {
                        "id": 53,
                        "name": "Spon, sepatu, sandal bekas",
                        "hierarchy_id": 1,
                        "material": "Lainnya",
                        "created_at": "2021-03-18 15:35:28",
                        "updated_at": "2021-03-18 15:35:28"
                    }
                ],
                Organic: [
                    {
                        "id": 82,
                        "name": "Organic",
                        "hierarchy_id": 1,
                        "material": "Organic",
                        "created_at": "2021-06-08 10:17:12",
                        "updated_at": "2021-06-08 10:17:12"
                    }
                ]
            },
            routes: [
                {
                  "id": 13456,
                  "date_slot": "2023-09-13 (Afternoon)",
                  "name": "Pankaj",
                  "mobile": "9873643943",
                  "house_no": "23",
                  "agent": "Kumar",
                  "status": "pending",
                  "payment": "",
                  "total_kgs": "34",
                  "comment": ""
                },
                {
                  "id": 23457,
                  "date_slot": "2023-09-14 (Morning)",
                  "name": "Amit",
                  "mobile": "8765432109",
                  "house_no": "42",
                  "agent": "Singh",
                  "status": "completed",
                  "payment": "",
                  "total_kgs": "25",
                  "comment": ""
                },
                {
                  "id": 34568,
                  "date_slot": "2023-09-15 (Evening)",
                  "name": "Sara",
                  "mobile": "7890123456",
                  "house_no": "7",
                  "agent": "Patel",
                  "status": "pending",
                  "payment": "",
                  "total_kgs": "42",
                  "comment": ""
                },
                {
                  "id": 45679,
                  "date_slot": "2023-09-16 (Afternoon)",
                  "name": "John",
                  "mobile": "1234567890",
                  "house_no": "56",
                  "agent": "Smith",
                  "status": "completed",
                  "payment": "",
                  "total_kgs": "31",
                  "comment": ""
                },
                {
                  "id": 56780,
                  "date_slot": "2023-09-17 (Morning)",
                  "name": "Maria",
                  "mobile": "9876543210",
                  "house_no": "11",
                  "agent": "Gonzalez",
                  "status": "pending",
                  "payment": "",
                  "total_kgs": "29",
                  "comment": ""
                },
                {
                  "id": 67891,
                  "date_slot": "2023-09-18 (Evening)",
                  "name": "David",
                  "mobile": "3456789012",
                  "house_no": "31",
                  "agent": "Johnson",
                  "status": "completed",
                  "payment": "",
                  "total_kgs": "37",
                  "comment": ""
                },
                {
                  "id": 78902,
                  "date_slot": "2023-09-19 (Afternoon)",
                  "name": "Linda",
                  "mobile": "2345678901",
                  "house_no": "19",
                  "agent": "Brown",
                  "status": "pending",
                  "payment": "",
                  "total_kgs": "40",
                  "comment": ""
                }
              ]              
        })
    }

    public render() {
        if (!localStorage.getItem('token')) {
            return (
                <Redirect to="/login" />
            );
        }
        const { t } = this.props;
        const open = Boolean(this.state.anchorEl);

        const handleMoreOptions = (event: React.MouseEvent<HTMLElement>) => {
            this.setState({ anchorEl: event.currentTarget });
        };

        const handleAddWaste = (() => {
            this.setState({ showAddWaste: false });
            toast.success("Outgoing waste added", {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored"
            });
        });

        const columns: any = [
            {
                headerName: "Id",
                field: "id",
                width: 150,
                renderCell: (params: GridCellParams) => (
                    <Link to={`/operations/bag-distribution/batches/bag-details/${params.id}`} style={{ textDecoration: 'none' }}>{params.row.id}</Link>
                )
            },
            {
                headerName: "Date(Slot)",
                field: "date_slot",
                width: 120
            },
            {
                headerName: "Name",
                field: "name",
                width: 80
            },
            {
                headerName: "Mobile",
                field: "mobile",
                width: 80
            },
            {
                headerName: "House No.",
                field: "house_no",
                width: 100
            },
            {
                headerName: "Agent",
                field: "agent",
                width: 150
            },
            {
                headerName: "Status",
                field: "status",
                width: 150
            },
            {
                headerName: "Payment",
                field: "payment",
                width: 150
            },
            {
                headerName: "Total kg",
                field: "total_kgs",
                width: 150
            },
            {
                headerName: "Comment",
                field: "comment",
                width: 150
            },
            {
                headerName: "Actions",
                field: 'actions',
                type: 'actions',
                getActions: (params: GridRowParams) => [
                    <GridActionsCellItem
                        // icon={<FileCopyIcon />}    
                        label="Edit Sorted Waste"
                        onClick={() => console.log(params.id)}
                        showInMenu
                    />,
                    <GridActionsCellItem
                        label="Delete"
                        onClick={() => console.log(params.id)}
                        showInMenu
                    />
                ]
            }
        ];

        return (
            <div>
                <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={true}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                />
                <OperationsHeader />
                <Grid container spacing={2}>
                    <Grid item md={12} xs={12} className="mt-3">
                        <Card>
                            <CardHeader
                                title={
                                    <Grid container spacing={2}>
                                        <Grid item md={3} xs={12}>
                                            <Typography variant='h5' className='MuiCardHeader-title' sx={{ lineHeight: "40px" }}>{t("Neighbourhood Distribution")}</Typography>
                                        </Grid>
                                        <Grid item md={3} xs={12}>
                                            <FormControl fullWidth={true} size="small">
                                                <TextField
                                                    id="filter-input"
                                                    label={t("Search")}
                                                    name="filter"
                                                    value={this.state.filter}
                                                    // onChange={(e: any) => this.setState({ "filter": e.target.value }, () => this.fetchRoutes())}
                                                    fullWidth={true}
                                                    size="small"
                                                />
                                            </FormControl>
                                        </Grid>
                                        <Grid item md={3} xs={12}>
                                            <FormControl fullWidth={true} size="small">
                                                <InputLabel id="route-type-label">{t("Pickup Status")}</InputLabel>
                                                <Select
                                                    labelId="route-type-label"
                                                    value={this.state.community_type}
                                                    // onChange={(e: any) => this.setState({ "community_type": e.target.value }, () => this.fetchRoutes())}
                                                    displayEmpty
                                                    label={t("Type")}
                                                >
                                                    <MenuItem key={'all'} value={'all'}>{t("All")}</MenuItem>
                                                    <MenuItem key={'Pending'} value={'Pending'}>{t("Pending")}</MenuItem>
                                                    <MenuItem key={'Complete'} value={'Complete'}>{t("Complete")}</MenuItem>
                                                    <MenuItem key={'Skipped'} value={'Skipped'}>{t("Skipped")}</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        <Grid item md={3} xs={12}>
                                            <FormControl fullWidth={true} size="small">
                                                <InputLabel id="route-type-label">{t("Select POD")}</InputLabel>
                                                <Select
                                                    labelId="route-type-label"
                                                    value={this.state.community_type}
                                                    // onChange={(e: any) => this.setState({ "community_type": e.target.value }, () => this.fetchRoutes())}
                                                    displayEmpty
                                                    label={t("Type")}
                                                >
                                                    <MenuItem key={'club_house_pod'} value={'club_house_pod'}>{t("Club House Pod")}</MenuItem>
                                                    <MenuItem key={'individual_hh_pod'} value={'individual_hh_pod'}>{t("Individual HH POD")}</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                        
                                    </Grid>
                                }
                                className="text-left"
                                action={
                                    <CardActions sx={{mt: "-4px"}}>
                                        <Button variant="contained" size='medium' sx={{ outline: 'none !important' }} 
                                        // onClick={() => {this.setState({ showAddRoute: true }) }}
                                        >
                                            {t("Print POD")}
                                        </Button>
                                        <Button variant="contained" size='medium' sx={{ outline: 'none !important' }} 
                                        // onClick={() => {this.setState({ showAddRoute: true }) }}
                                        >
                                            {t("Download POD")}
                                        </Button>
                                    </CardActions>
                                }
                            />
                            {/* <CardActions>
                                <Button variant='contained' sx={{ outline: 'none !important' }} onClick={() => this.setState({ showAddWaste: true })}><Add /> Add Outgoing Waste</Button>
                            </CardActions> */}
                            <CardContent>
                                <DataGrid
                                    aria-label="Outgoing Waste List"
                                    columns={columns}
                                    rows={this.state.routes}
                                    pageSize={this.state.pageSize}
                                    onPageSizeChange={(newPageSize) => this.setState({ pageSize: newPageSize })}
                                    rowsPerPageOptions={[2, 5, 10, 20]}
                                    autoHeight={true}
                                    components={{
                                        MoreActionsIcon: EditOutlined,
                                        Toolbar: CustomToolbar
                                    }}
                                    componentsProps={{ toolbar: { csvOptions: { fileName: 'Tickets-list' } } }}
                                    // checkboxSelection
                                />
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
                <Modal
                    open={this.state.showAddWaste}
                    onClose={() => this.setState({ showAddWaste: false })}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Card>
                            <CardHeader
                                title="Add Waste"
                                className="text-left"
                                action={
                                    <IconButton color="primary" className='customIconButton' aria-label="upload picture" component="span" onClick={() => this.setState({ showAddWaste: false })}>
                                        <CloseOutlined />
                                    </IconButton>
                                }
                            />
                            <CardContent>
                                <Divider className="mb-3" />
                                <Grid container spacing={2}>
                                    <Grid item md={3} xs={12}>
                                        <TextField
                                            id="waste-quantity-input"
                                            label="Waste Quantity *"
                                            value={this.state.waste_quantity}
                                            type="number"
                                            onChange={(e: any) => this.setState({ waste_quantity: e.target.value })}
                                            fullWidth={true}
                                        />
                                    </Grid>
                                    <Grid item md={3} xs={12}>
                                        <FormControl fullWidth={true}>
                                            <InputLabel id="unit-label">Unit *</InputLabel>
                                            <Select
                                                labelId="unit-label"
                                                value={this.state.unit}
                                                onChange={(e) => this.setState({ unit: e.target.value })}
                                                displayEmpty
                                                label="Unit *"
                                                fullWidth={true}
                                            >
                                                <MenuItem key={1} value={1}>KG</MenuItem>
                                                <MenuItem key={2} value={2}>Bottles</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item md={3} xs={12}>
                                        <FormControl fullWidth={true}>
                                            <InputLabel id="material-select-label">Material *</InputLabel>
                                            <Select
                                                labelId="material-select-label"
                                                value={this.state.material}
                                                onChange={(e) => this.setState({ material: e.target.value, types: this.state.material_types[e.target.value] })}
                                                displayEmpty
                                                label="Material *"
                                                fullWidth={true}
                                            >
                                                {
                                                    Object.keys(this.state.material_types).map(function (key) {
                                                        return <MenuItem key={key} value={key}>{key}</MenuItem>;
                                                    })
                                                }
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item md={3} xs={12}>
                                        <FormControl fullWidth={true}>
                                            <InputLabel id="material-types-select-label">Type *</InputLabel>
                                            <Select
                                                labelId="material-types-select-label"
                                                value={this.state.material_type}
                                                onChange={(e) => this.setState({ material_type: e.target.value })}
                                                displayEmpty
                                                label="Type *"
                                                fullWidth={true}
                                            >
                                                {
                                                    this.state.types.map((type: any) => {
                                                        return <MenuItem key={type.id} value={type.id}>{type.name}</MenuItem>;
                                                    })
                                                }
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item md={3} xs={12}>
                                        <TextField
                                            id="price-per-unit-input"
                                            label="Price Per Unit *"
                                            value={this.state.price_per_unit}
                                            type="number"
                                            InputProps={{
                                                inputProps: { min: 0, max: 100 }
                                            }}
                                            onChange={(e: any) => this.setState({ price_per_unit: e.target.value, total_price: ((this.state.waste_quantity) ? (this.state.waste_quantity * e.target.value) : 0) })}
                                            fullWidth={true}
                                        />
                                    </Grid>
                                    <Grid item md={3} xs={12}>
                                        <TextField
                                            id="total-price-input"
                                            label="Total Price *"
                                            value={this.state.total_price}
                                            InputProps={{
                                                readOnly: true,
                                            }}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            fullWidth={true}
                                        />
                                    </Grid>
                                    <Grid item md={3} xs={12}>
                                        <FormControl fullWidth={true}>
                                            <TextField
                                                id="buyers-input"
                                                label="Buyers *"
                                                onChange={(e: any) => console.log(e.target.value)}
                                                fullWidth={true}
                                            />
                                        </FormControl>
                                    </Grid>
                                    <Grid item md={3} xs={12}>
                                        <FormControl fullWidth={true}>
                                            <TextField
                                                id="receipt-id-input"
                                                label="Receipt ID *"
                                                onChange={(e: any) => console.log(e.target.value)}
                                                fullWidth={true}
                                            />
                                        </FormControl>
                                    </Grid>
                                    <Grid item md={4} xs={12}>
                                        <FormControl fullWidth={true}>
                                            <InputLabel id="routes-select-label">Route *</InputLabel>
                                            <Select
                                                labelId="routes-select-label"
                                                value={this.state.route_id}
                                                onChange={(e) => this.setState({ route_id: e.target.value })}
                                                displayEmpty
                                                label="Route *"
                                                fullWidth={true}
                                            >
                                                {
                                                    this.state.routes.map((route) => {
                                                        return <MenuItem key={route.id} value={route.id}>{route.route}</MenuItem>
                                                    })
                                                }
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item md={4} xs={12}>
                                        <FormControl fullWidth={true}>
                                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                <DateTimePicker
                                                    renderInput={(props) => <TextField {...props} />}
                                                    label="Date Time *"
                                                    value={this.state.date}
                                                    onChange={(newValue: any) => {
                                                        this.setState({ date: newValue });
                                                    }}
                                                />
                                            </LocalizationProvider>
                                        </FormControl>
                                    </Grid>
                                    <Grid item md={4} xs={12}>
                                        <FormControl fullWidth={true}>
                                            <TextField
                                                id="description-input"
                                                label="Description (Optional)"
                                                onChange={(e: any) => console.log(e.target.value)}
                                                fullWidth={true}
                                            />
                                        </FormControl>
                                    </Grid>
                                </Grid>
                                <Divider className='mt-3' />
                            </CardContent>
                            <CardActions className='float-right'>
                                <Button size='small' className='customCloseButton' onClick={() => this.setState({ showAddWaste: false })}>Close</Button>
                                <Button size='small' variant='contained' sx={{ outline: 'none !important' }} onClick={() => handleAddWaste()}>Add Waste</Button>
                            </CardActions>
                        </Card>
                    </Box>
                </Modal>
            </div>
        )
    }
}

export default withRouter(withTranslation()(Distribution))